'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiPencil = function TiPencil(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35 11.5l-6.5-6.5c-0.5-0.5-1.1-0.7-1.7-0.7-0.7 0-1.3 0.2-1.8 0.7l-18.2 18.2c-0.5 0.5-1 1.2-1.3 2-0.3 0.8-0.5 1.6-0.5 2.3v7.5h7.5c0.7 0 1.5-0.2 2.3-0.5s1.5-0.8 2-1.3l18.2-18.2c0.5-0.5 0.7-1.1 0.7-1.8 0-0.6-0.2-1.2-0.7-1.7z m-25.4 13.6l13.8-13.8 2.1 2-13.8 13.9-2.1-2.1z m2.9 6.6h-2.5l-1.7-1.7v-2.5c0-0.1 0.1-0.5 0.3-1 0 0 4.9 4.9 4.9 4.9-0.5 0.2-0.9 0.3-1 0.3z m2.4-1.3l-2.1-2.1 13.9-13.8 2 2.1-13.8 13.8z m15-15l-5.3-5.3 2.2-2.2 5.2 5.3-2.1 2.2z' })
        )
    );
};

exports.default = TiPencil;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/pencil.js
// module id = 3159
// module chunks = 0